<template>
  <transition-group tag="div" appear class="listing-feed__set" data-layout="3" name="fade-up">
    <event-card :hide-tags="hideTags" :default-selected-tags="defaultSelectedTags" v-for="(item, index) in data" :item="item" :index="index" :key="item.Id" />
  </transition-group>
</template>

<script>

import EventCard from './event-card.vue'

export default {
    components: {
        EventCard
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>